import RecreateDialog from './RecreateDialog';

export default { 
  name: "recreate", 
  component: RecreateDialog, 
  fullScreen: false
};